import {
  ekycCheckingStatus,
  getLoanAsync,
  loading,
  setApplicationId,
  setCreditScoreResult,
  setDisburseLifetime,
  setFreezeDateSuccess,
  setHomePath,
  setloanAmountSelected,
  setNextDate,
  setError,
  statusPayment,
  setIsFlowSuplesiActive
} from 'store/actions';
import { handleCreditScoreStatus } from './creditScoreHandler';
import {
  clearPaymentLocalStorage,
  isObjectEmpty,
  resetLocalStorageForDisburse,
  resetLocalStorageForPaidOffSuplesi
} from 'helpers/Utility';

const handlePaidDisbProcess = history => {
  history.push('/suplesi/paid-disb-process');
  return;
};

const handleDisburseInProcess = (dispatch, data, getState) => {
  dispatch(setHomePath('/continue-disburse'));
  if (!getState().loanApply.disburseLifetime) {
    dispatch(
      setDisburseLifetime(data.disbursementDetails?.disburseLifetime || 0)
    );
  }
  if (data.suplesiData?.applicationStatus === 'DISB_IN_PROCESS') {
    dispatch(setIsFlowSuplesiActive(true));
  }
};

const handlePaidSupFailed = (dispatch, data, params) => {
  if (data?.suplesiData?.applicationStatus !== 'PAID_SUP_FAILED') return;

  resetLocalStorageForPaidOffSuplesi();
  dispatch(statusPayment('FAILURE'));
  dispatch(setIsFlowSuplesiActive(true));
  params?.paidSupFailed?.();
  return;
};

const handleLoanCreated = (dispatch, data, auth, params) => {
  if (params?.checkingStatus) return params.checkingStatus();
  resetLocalStorageForDisburse();
  return dispatch(
    getLoanAsync(
      { phoneNo: auth.phoneNo, token: auth.token },
      {
        action: () => {
          dispatch(setHomePath('/disburse-fin'));
          handlePaidSupFailed(dispatch, data, params);
        },
        actionEndOfDay: params?.actionEndOfDay,
        noLoading: params?.noLoading
      }
    )
  );
};

const handleLoanPaid = (dispatch, data, history) => {
  clearPaymentLocalStorage(dispatch);
  dispatch(setHomePath('/home'));
  if (data.timeFreezeApply) {
    dispatch(setFreezeDateSuccess(data.timeFreezeApply));
  } else {
    localStorage.removeItem('freezeDateSuccess');
  }

  const arrSuplesiStatus = ['PAID_SUP_PROCESS', 'PAID_SUP_SUCCESS'];

  if (
    !isObjectEmpty(data.suplesiData) &&
    arrSuplesiStatus.includes(data.suplesiData?.applicationStatus)
  ) {
    handlePaidDisbProcess(history);

    if (data.suplesiData.applicationStatus === 'PAID_SUP_SUCCESS') {
      resetLocalStorageForPaidOffSuplesi();
    }
    return;
  }
};

/**
 * to handle application status
 * @param {*} dispatch
 * @param {*} appStatus
 * @param {*} data
 * @param {*} auth
 * @param {*} params
 * @param {*} ekycStatus
 * @param {*} history
 * @returns
 */
export const handleApplicationStatus = async ({
  dispatch,
  appStatus,
  data,
  auth,
  context
}) => {
  const { params, ekycStatus, getState, history } = context;
  if (data.isExpired && data.isSecondApply !== 'Y') return;
  if (!appStatus) return dispatch(loading(false));

  if (appStatus.includes('_SAVED')) {
    dispatch(setHomePath('/continue-apply'));
    return dispatch(loading(false));
  }

  if (appStatus.includes('CR_SCORE')) {
    handleCreditScoreStatus(dispatch, appStatus, data, params);
    return;
  }

  const statusHandlers = {
    KTP_REJECT: () => {
      dispatch(setCreditScoreResult('ktp-reject'));
      dispatch(setHomePath('/credit-scoring'));
    },
    DISB_ACC_CONF: () => {
      if (ekycStatus === 'P') {
        dispatch(
          ekycCheckingStatus({ ...auth, applicationId: data.applicationId })
        );
      }
      dispatch(setHomePath('/continue-disburse'));
    },
    EKYC_COM: () => dispatch(setHomePath('/continue-disburse')),
    RE_EKYC: () => dispatch(setHomePath('/continue-disburse')),
    RE_EKYC_COM: () => dispatch(setHomePath('/continue-disburse')),
    DOCUMENT_SIGN: () => dispatch(setHomePath('/continue-disburse')),
    DOCUMENT_SIGNED: () => {
      dispatch(setHomePath('/continue-disburse'));
      resetLocalStorageForDisburse();
    },
    DISB_IN_PROCESS: () => handleDisburseInProcess(dispatch, data, getState),
    DIG_SIGN_COM: () => {
      dispatch(setHomePath('/continue-disburse'));
      dispatch(
        setloanAmountSelected(data.incompleteApplicationDetails.approvalAmount)
      );
    },
    LOAN_CREATED: () => handleLoanCreated(dispatch, data, auth, params),
    LOAN_PAID: () => handleLoanPaid(dispatch, data, history),
    APP_EXPIRED: () => {
      if (data.previousLoanPaidAppId) {
        dispatch(setApplicationId(data.previousLoanPaidAppId));
      }
    },
    PAYROLL_REJ: () => {
      dispatch(setHomePath('/home'));
      dispatch(setNextDate(data.payrollrejdetails.nextEligibilityDate));
    },
    PAYROLL_APP: () => dispatch(setHomePath('/continue-apply')),
    APP_CREATED: () => dispatch(setHomePath('/continue-apply')),
    USR_REJECT: () => {
      dispatch(setHomePath('/home'));
      dispatch(setNextDate(data.rejectionDetails.nextEligibilityDate));
    },
    PAID_SUP_FAILED: () => {
      handlePaidSupFailed(dispatch, data, params);
    }
    // PAID_SUP_PROCESS: () =>
    // handlePaidSubProcess(dispatch, data, getState, history)
  };
  await statusHandlers[appStatus]?.();
  dispatch(loading(false));
};

export const handleEOD = (params, history, appStatus, dispatch, data) => {
  if (typeof params?.actionEndOfDay === 'function') {
    params?.actionEndOfDay(data);
    return;
  }
  history.push('/home');
  dispatch(
    setHomePath(appStatus !== 'LOAN_CREATED' ? '/home' : '/disburse-fin')
  );
  dispatch(setError(''));
};
